import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { Sentry } from "@/lib/sentry";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useDocumentTitle("Page Not Found");

  useEffect(() => {
    // Silent for users (no console.error); leave a Sentry breadcrumb so a 404
    // that precedes a real error report still shows up in its context trail.
    Sentry.addBreadcrumb({
      category: "navigation",
      message: `404: ${location.pathname}`,
      level: "warning",
    });
  }, [location.pathname]);

  return (
    <div className="min-h-svh bg-background flex flex-col">
      <header className="border-b border-border bg-card">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center">
          <BrandLogo to="/" height="h-8" />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
            <Search className="h-8 w-8 text-muted-foreground" />
          </div>
          <h1 className="font-display text-5xl font-bold text-foreground mb-2">404</h1>
          <p className="text-lg text-muted-foreground mb-2">Page not found</p>
          <p className="text-sm text-muted-foreground mb-8">
            The page <code className="text-xs bg-muted px-1.5 py-0.5 rounded font-mono">{location.pathname}</code> doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button variant="mint" asChild>
              <Link to="/"><Home className="h-4 w-4 me-1.5" /> Go Home</Link>
            </Button>
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="h-4 w-4 me-1.5" /> Go Back
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
